// removed by extract-text-webpack-plugin
module.exports = {"otherEvents":"_8xNv1-rprNq0zv4vqimQY","otherEvent":"_15oA_HTdm6t7IoX67jbrnB","project":"_2qG-7yH2tAZz4JyQIsiRgF","image":"_1J7vxpJHcSO-Wes-xbHSBz","title":"_32fQaSfFtEQSYI-xDoU3F"};


//////////////////
// WEBPACK FOOTER
// ../components/Event/style.module.less
// module id = 997
// module chunks = 0